import api, { API_BASE_URL } from '../api/axios';

// Default export = URL string (backward compatible with all existing components)
export default API_BASE_URL;
export { api, API_BASE_URL };
